// The /chat landing covers the whole viewport (z-60), above the site's dialogs, so a logged-out visitor
// signs up, logs in and verifies their phone on /login. The request the chat built waits here meanwhile.
const KEY = 'ofair_chat_pending_request';
const MAX_AGE_MS = 60 * 60 * 1000;

export interface PendingChatFields {
  profession: string;
  city: string;
  description: string;
  timing: string;
  phone: string;
}

export const savePendingChatRequest = (fields: PendingChatFields): void => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ fields, savedAt: Date.now() }));
  } catch (error) {
    console.error('Error saving pending chat request:', error);
  }
};

export const loadPendingChatRequest = (): PendingChatFields | null => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { fields, savedAt } = JSON.parse(raw) as { fields: PendingChatFields; savedAt: number };
    if (!fields || Date.now() - savedAt > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return fields;
  } catch {
    return null;
  }
};

export const clearPendingChatRequest = (): void => {
  try {
    localStorage.removeItem(KEY);
  } catch (error) {
    console.error('Error clearing pending chat request:', error);
  }
};
